/** Image path for a high-level voter issue (`public/images/{slug}.jpg`). */
export function getCategoryImageUrl(issue: { slug: string }): string {
  return `/images/${issue.slug}.jpg`;
}
